import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/categories";

export default function SEOTextSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 font-[family-name:var(--font-heading)] text-center">
          Why Smart Shoppers Choose <span className="italic">GTBuy Sheet</span>
        </h2>

        <div className="space-y-6 text-sm md:text-base text-foreground-700 leading-relaxed font-[family-name:var(--font-body)] font-light">
          <p>
            In the rapidly evolving world of online shopping, having a reliable comparison system is no longer
            optional—it is essential. The <strong>gtbuy spreadsheet</strong> has emerged as the go-to solution
            for shoppers who refuse to settle for less than the best deal. Whether you are browsing for
            <strong> Shoes</strong>, exploring the latest <strong>Hoodies and Sweaters</strong>, searching for
            the perfect <strong>T-Shirts</strong>, or comparing <strong>Jackets</strong> across multiple retailers,
            the GTBuy sheet puts all the information you need right at your fingertips.
          </p>

          <p>
            What makes the GTBuy spreadsheet truly stand out is its unmatched versatility across categories.
            From <strong>Pants and Shorts</strong> to <strong>Headwear</strong>, coordinated <strong>Sets</strong>,
            comfortable <strong>Underwear</strong>, performance <strong>Jersey</strong> apparel, stylish
            <strong> Accessories</strong>, practical <strong>Bags</strong>, classic <strong>Belts</strong>,
            luxurious <strong>Perfumes</strong>, and all kinds of <strong>Other Stuff</strong>—every product
            category benefits from the structured comparison framework that the GTBuy sheet provides. No
            matter what you are shopping for, the system adapts to your specific needs.
          </p>

          <p>
            The beauty of the <Link to="/article/gtbuy-spreadsheet-guide" className="text-primary-600 hover:text-primary-700 underline cursor-pointer">GTBuy spreadsheet system</Link> lies in
            its simplicity. You do not need to be a data analyst or spreadsheet expert to get started. The
            intuitive layout guides you through the comparison process step by step, helping you input product
            details, track prices over time, and identify the best value with minimal effort. As you become more
            comfortable with the system, you can unlock advanced features that take your shopping optimization
            to the next level.
          </p>

          <p>
            Beyond individual savings, the GTBuy sheet fosters a smarter approach to consumption. By making
            informed, data-driven decisions, shoppers naturally gravitate toward higher-quality products that
            offer better long-term value. This shift away from impulse buying and toward strategic purchasing
            benefits both your wallet and your overall satisfaction with every purchase you make.
          </p>

          <div className="bg-background-100 border border-background-200/60 rounded-lg p-6 md:p-8 mt-8">
            <h3 className="text-lg font-semibold text-foreground-950 mb-3 font-[family-name:var(--font-heading)]">
              Ready to Transform Your Shopping?
            </h3>
            <p className="text-sm text-foreground-600 mb-5 font-[family-name:var(--font-body)]">
              Visit the main GTBuy platform to access the full spreadsheet system and start comparing products like a pro.
            </p>
            <a
              href={siteConfig.mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Go to KASpreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}